export default __webpack_public_path__ + "static/media/harry-potter-saga.38b5e0f6.svg";